var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArrowDownOutlineInverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "masked-down-arrow-group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "down-arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(32 32) scale(1.5)",
    points: "11.24 4.5 11.24 16.62 8.31 13.69 7.26 14.74 12.02 19.5 16.76 14.75 15.71 13.69 12.73 16.67 12.73 4.5 11.24 4.5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    mask: "url(#down-arrow)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow-group"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(32 32) scale(1.5)",
    fill: "#fff",
    points: "11.24 4.5 11.24 16.62 8.31 13.69 7.26 14.74 12.02 19.5 16.76 14.75 15.71 13.69 12.73 16.67 12.73 4.5 11.24 4.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownOutlineInverse);
export default __webpack_public_path__ + "static/media/ic_arrow_down_outline_inverse.623b6486.svg";
export { ForwardRef as ReactComponent };